// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { minus16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-minus': IconMinus;
    }
}

/**
 * The icon component for the 'minus' icon
 */
export class IconMinus extends Icon {
    public constructor() {
        super(minus16X16);
    }
}

registerIcon('icon-minus', IconMinus);
export const iconMinusTag = 'nimble-icon-minus';
